export default __webpack_public_path__ + "static/media/ico-close-white.90f7a75c.svg";